import {Component, Input, OnInit, inject, Output, EventEmitter} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  FormGroupDirective,
  ReactiveFormsModule
} from '@angular/forms';

import {faBars, faEye, faPencil, faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ProblemTemplate} from "../../construct.component";
import { DropdownSearchComponent } from 'src/app/shared/ui/dropdown-search/dropdown-search.component';
import {FullButtonComponent} from "../../../../../../shared/ui/full-button/full-button.component";
import {ContentService} from "../../../../../../admin/data-access/content.service";
import {TooltipDirective} from "../../../../../../shared/ui/tooltip/tooltip.component";
import {
  FullProblemTemplate
} from "../../../../../../admin/feature/contentViewer/problemTemplatePreview/problemTemplatePreview.component";
import {
  MultipleChoiceComponent
} from "../../../../../../shared/ui/problem-templates/multiplechoice/multiplechoice.component";
import {MultifieldComponent} from "../../../../../../shared/ui/problem-templates/multifield/multifield.component";
import {MathjaxModule} from "mathjax-angular";
import {CCL, Pools, Question, Subject} from "../../construct.component";
import {
  LearningObjective
} from "../../../../../../admin/feature/contentViewer/learningObjective/learningObjective.component";
import {ActivatedRoute} from "@angular/router";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'pool-question',
    templateUrl: './pool-questions.component.html',
    styleUrls: ['../../../../../../admin/feature/userManagement/userRoleAddEdit/userRoleAddEdit.css', '../../construct.component.css'],
    imports: [ReactiveFormsModule, FontAwesomeModule, DropdownSearchComponent, FullButtonComponent, TooltipDirective,
      MultipleChoiceComponent, MultifieldComponent, MathjaxModule, DragDropModule]
})
export class PoolQuestionsComponent implements OnInit {
  @Input() index!: number
  rootFormGroup = inject(FormGroupDirective);
  contentService = inject(ContentService)
  route = inject(ActivatedRoute)
  @Input() formGroupName!: string;
  @Input() problemTemplates: ProblemTemplate[] = []
  addedProblemTemplate: ProblemTemplate[][] = []
  poolQuestionFormSection!: FormArray;
  faBars = faBars
  faXmark = faXmark
  previewDialog = false
  previewProblemTemplate: FullProblemTemplate = {
    answerSkeleton: [],
    answers: [],
    clusters: [],
    details: {
      allItems: [],
      allGroups: []
    },
    learningobjective_id: 0,
    mathjax: false,
    problemtemplate_id: 0,
    problemtemplate_name: "",
    question_text: "",
    reasons: [],
    sampleCases: [],
    samplesInitial: 0,
    samplesRemaining: 0,
    type: "",
    values: []
  }
  @Input() allSubjectsAdded: Subject[] = []
  @Output() allSubjectsAddedChange = new EventEmitter<Subject[]>()
  @Input() addedLearningObjective: LearningObjective[] = []
  @Output() addedLearningObjectiveChange = new EventEmitter<LearningObjective[]>()
  isEdit = false
  inputDialog = false

  ngOnInit() {
    this.poolQuestionFormSection = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormArray;
    this.route.queryParams.subscribe(params => {
      if(params['edit'])
        this.isEdit = true
    })
    for(let i = 0; i < this.questions.controls.length; i++) {
      if(this.questions.controls[i].get('problemtemplate_id') !== null) {
        this.contentService.getProblemTemplatePreview(this.questions.controls[i].get('problemtemplate_id')?.value).subscribe((response) => {
          if(response.success) {
            const tempArray: ProblemTemplate[] = [{
              name: response.result[0].problemtemplate_name,
              ...response.result[0]
            }]
            this.addedProblemTemplate[i] = tempArray.splice(0)

            // This is a check for when exam is being edited to add back the LOs
            if(this.isEdit) {
              for(let pt of this.addedProblemTemplate[i]) {
                this.contentService.listProblemTemplates(pt.learningobjective_id, 0, -1, "", "", false).subscribe((response) => {
                  if(response.success) {
                    for(let item of response.result.items) {
                      if(!this.problemTemplates.some(el => el.problemtemplate_id === item.problemtemplate_id)) {
                        this.problemTemplates.push(item)
                      }
                    }
                  } else if(response.msg === 'No learningobjectives found') {
                    // TODO need to find a way to handle this specific issue
                  }
                })
              }
            }
          }
        })
      }
    }
  }

  get qpool(): FormGroup {
    return this.poolQuestionFormSection.at(this.index) as FormGroup
  }

  get questions(): FormArray {
    return this.qpool.get('questions') as FormArray
  }

  addNewQuestion() {
    const question: FormGroup = new FormGroup({
      // TODO fill the ids with correct information
      examquestion_id: new FormControl(null),
      examqpool_id: new FormControl(this.qpool.get('examqpool_id')?.value),
      question_position: new FormControl(this.questions.length + 1),
      problemtemplate_id: new FormControl(null),
      source: new FormControl(""),
      source_id: new FormControl("")
    })
    this.questions.push(question)
    if(this.qpool.get('questions_used')?.value >= this.questions.length-1 || this.qpool.get('questions_used')?.value == null)
      this.qpool.get('questions_used')?.setValue(this.questions.length)
    this.addedProblemTemplate.push([])
  }

  updateProblemTemplateID(form: AbstractControl, index: number) {
    if(this.addedProblemTemplate.length > 0)
      form.get('problemtemplate_id')?.setValue(this.addedProblemTemplate[index][0].problemtemplate_id)
    else
      form.get('problemtemplate_id')?.setValue(null)
  }

  removeQuestion(index: number) {
    if(this.qpool.get('questions_used')?.value >= this.questions.length-1 || this.qpool.get('questions_used')?.value == null)
      this.qpool.get('questions_used')?.setValue(this.questions.length-1)
    this.questions.removeAt(index)
    this.addedProblemTemplate.splice(index, 1)
  }

  openPreviewDialog(control: AbstractControl) {
    this.previewDialog = true
    this.contentService.getProblemTemplatePreview(control.get('problemtemplate_id')?.value).subscribe((response) => {
      if (response.success) {
        this.previewProblemTemplate = response.result[0]
      }
    })
  }

  openEditInputVariables(problemtemplate_id: number) {
    this.inputDialog = true
  }

  drop(event: CdkDragDrop<FormGroup[]>) {
    const dir = event.currentIndex > event.previousIndex ? 1 : -1;

    const from = event.previousIndex;
    const to = event.currentIndex;

    const temp = this.questions.at(from);
    for (let i = from; i * dir < to * dir; i = i + dir) {
      const current = this.questions.at(i + dir);
      this.questions.setControl(i, current);
    }
    this.questions.setControl(to, temp);
    this.questions.at(event.currentIndex).get('question_position')?.setValue(event.currentIndex + 1)
    this.questions.at(event.previousIndex).get('question_position')?.setValue(event.previousIndex + 1)
    moveItemInArray(this.addedProblemTemplate, event.currentIndex, event.previousIndex)
  }

  protected readonly faEye = faEye;
  protected readonly faPencil = faPencil;
}
